import { PanelGroup } from 'react-resizable-panels';

export const ResizableGroup = ({
  children,
  widthPersistKey,
  className,
}: {
  children: React.ReactNode;
  widthPersistKey?: string;
  className?: string;
}) => {
  return (
    <PanelGroup
      direction="horizontal"
      autoSaveId={widthPersistKey}
      className={className}
    >
      {children}
    </PanelGroup>
  );
};
